<template>
  <div
    class="courseDjustment-content-item"
    v-show="isCurrentContentItem"
    v-bitmap="getListResult"
  >
    <courseDjustmentList
      :courseDjustmentList="courseDjustmentList"
      class="courseDjustment-list-content-main"
      :courseDjustmentStatus="currentStatus"
      @updateStatus="updateStatus"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import courseDjustmentList from "../courseDjustment-list/courseDjustment-list.vue";

export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageNum: 1,
      courseDjustmentList: null,
      getListResult: "nullData",
      testTotal: 1,
    };
  },
  components: {
    courseDjustmentList,
  },
  props: {
    isCurrentContentItem: {
      type: Boolean,
    },
    currentStatus: {
      type: Number,
      require: true,
    },
    changeStatus: {
      type: [Number, String],
    },
    searchContent: {
      type: String,
    },
    searchVenueNameContent: {
      type: String,
    },
  },
  watch: {
    // 切换列表显示
    isCurrentContentItem: {
      handler(val) {
        if (val && !this.courseDjustmentList) {
          this.getCourseDjustmentList();
          // console.log('切换1');
        }
      },
      immediate: true,
    },
    // 状态切换
    changeStatus: {
      handler(val) {
        if (val) {
          this.courseDjustmentList = null;
          if (this.isCurrentContentItem) {
            // console.log('切换2');
            this.getCourseDjustmentList();
          }
        }
      },
      immediate: true,
    },
    // 搜索词(监听变化，变化时重新请求数据)
    searchContent() {
      // console.log("item==>", this.searchContent);
      this.courseDjustmentList = null;
      if (this.isCurrentContentItem) {
        this.getCourseDjustmentList();
      }
    },
    searchVenueNameContent() {
      // console.log("item==>", this.searchContent);
      this.courseDjustmentList = null;
      if (this.isCurrentContentItem) {
        this.getCourseDjustmentList();
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取审批列表
    getCourseDjustmentList() {
      // console.log(this.searchContent);
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        // applyTeacherId: this.user.id,
        teacherId: this.user.id,
        // schoolId: this.user.schoolId,
        // teacherName: this.searchContent,
        // venueName: this.searchVenueNameContent,
        reviewStatus: this.currentStatus, // （0：待审核 1：通过 2：驳回 3：撤回
      };
      this.get(this.$url.getTeacherApplyForList, data)
        .then((res) => {
          // console.log("查询调课审核列表==>", res);
          this.courseDjustmentList = res.rows;
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error(res.msg);
            return;
          }
          let data = res;
          this.total = data.total;
          this.courseDjustmentList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getCourseDjustmentList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getCourseDjustmentList();
    },
    //
    updateStatus(e) {
      // console.log(e);
      this.$emit("updateStatus", e);
    },
    // 搜索
    // search(e) {
    //   // console.log(e);
    //   this.courseDjustmentList = null;
    //   if (e == "") {
    //     this.searchContent = "";
    //     this.getCourseDjustmentList();
    //   } else {
    //     this.searchContent = e;
    //     this.getCourseDjustmentList();
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseDjustment-content-item.scss";
</style>
